// Formats and returns a campaign payload object with all required campaign details
const formatValuesCampaign = ({
  // Destructure input parameters with default values
  user,
  campaignName = "",
  quantityValue = null,
  deliveryType = "",
  campaignType = "",
  country = null,
  brand = null,
  folder = null,
  afterSpecificNumberOfOccurrences = false,
  include = [],
  exclude = [],
  type = null,
  audienceGroups = [],
  timeValue = null,
  startDate = null,
  endDate = null,
  campaignId,
}: any): any => {
  // Construct a standardized payload object for campaign data
  const payload: any = {
    user,
    campaignName,
    quantityValue,
    deliveryType,
    country,
    brand,
    folder,
    afterSpecificNumberOfOccurrences,
    include,
    exclude,
    type,
    audienceGroups,
    timeValue,
    startDate,
    endDate,
    campaignType,
    campaignId,
  };

  return payload;
};

export default formatValuesCampaign;
